import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output
} from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { Observable } from "rxjs";
import { debounceTime, switchMap, tap } from "rxjs/operators";
import { LoadingDrivebService } from "@shared/components/loading-driveb/loading-driveb.service";
import { GenericComponent } from "../../components/generic.component";
import { VehicleBrandService } from "src/app/core/services/vehicle-brand.service";
import { VehicleModelDTO } from "../../models/vehicle-model-dto";
import { SearchFormDTO } from "./models/search-form-dto";
import { MatOptionSelectionChange } from "@angular/material/core";

@Component({
  selector: "app-driveb-vehicle-brand-auto-complete",
  templateUrl: "./vehicle-brand-auto-complete.component.html",
  styleUrls: ["./vehicle-brand-auto-complete.component.scss"],
  standalone: false
})
export class VehicleBrandAutoCompletePartsComponent
  extends GenericComponent
  implements OnInit
{
  loading = false;
  name = new FormControl();

  searchForm = this.fb.group({
    name: this.name
  });

  models = [];

  @Input() page = "";
  @Input() title = "";
  @Output() onChange: any = new EventEmitter<VehicleModelDTO>();

  constructor(
    private vehicleModelService: VehicleBrandService,
    injector: Injector,
    private loadingDrivebService: LoadingDrivebService
  ) {
    super(injector);
  }

  ngOnInit() {
    this.name.valueChanges
      .pipe(
        debounceTime(200),
        tap(
          () => (
            (this.loading = true), this.loadingDrivebService.setAutoMode(false)
          )
        ),
        switchMap((value: string) => {
          if (value) {
            const filters = {} as SearchFormDTO;
            filters.name = value;
            return this.vehicleModelService.listAllByFilters(filters);
          } else {
            this.loadingDrivebService.setAutoMode(true);
            this.loading = false;
            this.onChange.emit({} as VehicleModelDTO);
            return new Observable<VehicleModelDTO[]>();
          }
        })
      )
      .subscribe((data) => {
        this.models = data;
        this.loading = false;
        this.loadingDrivebService.setAutoMode(true);
      });
  }

  handleVehicleModelChange(
    event: MatOptionSelectionChange,
    model: VehicleModelDTO
  ) {
    if (event.isUserInput === true) {
      this.onChange.emit(model);
    }
  }

  clean(): void {
    this.searchForm.reset();
    this.models = [];
  }

  setValue(value: string): void {
    this.searchForm.get("name").setValue(value);
    this.models = [];
  }
}
